var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.252,
    cy: 7.203,
    r: 6.73,
    fill: "#66AE7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.696 4.496a.332.332 0 10-.47.47L8.693 7.43 6.227 9.897a.332.332 0 10.47.47l2.7-2.7c.13-.13.13-.34 0-.47l-2.7-2.701z",
    fill: "#fff"
  })));
};
export default __webpack_public_path__ + "static/media/Next.8f9a959a.svg";
export { SvgNext as ReactComponent };